import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
import {
  CaracteristicaComValor,
  AtualizarCaracteristicaValor,
} from "@/components/AtributoComValor"
import { defineStore } from "pinia"
import { estados } from "@/types/api"
import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"

interface CaracteristicaEstado {
  caracteristicas: CaracteristicaComValor[]
  estagioDaRequisicao: number
}

const { adicionarUmDia } = usarDataHora()

export const CaracteristicaStore = defineStore("caracteristicas", {
  state: (): CaracteristicaEstado => ({
    caracteristicas: [],
    estagioDaRequisicao: 0,
  }),
  getters: {
    buscarCaracteristicaPorId: (state) => {
      return (idAtributo: string) =>
        state.caracteristicas.find(
          (caracteristica) => caracteristica.id === idAtributo
        )
    },
  },
  actions: {
    atualizarCaracteristica(atualizador: AtualizarCaracteristicaValor) {
      const caracteristica = this.buscarCaracteristicaPorId(atualizador.id)

      if (caracteristica) {
        caracteristica.valor = atualizador.novoValor
      }
    },
    adicionarCaracteristica(caracteristicas: CaracteristicaComValor) {
      this.caracteristicas.push(caracteristicas)
    },
    async listarCaracteristicas() {
      const buscarAtributos = async () => {
        const { resultados: atributos } = await caracteristicasRepositorio.listarAtributos({
          tipo_do_atributo: "igual.caracteristica",
        })

        return atributos.map((atributo) => ({
          id: atributo.id!,
          nomeDoAtributo: atributo.nome,
          tipoDoValor: atributo.tipoDeValor,
          valor: "",
          deletavel: false,
          valoresPossiveis: atributo.valoresPossiveis,
          listaDeMultiplaEscolha: atributo.listaDeMultiplaEscolha,
        }))
      }

      const buscarCaracteristicasDoProfissional = async (idsDasCaracteristicas) => {
        const { resultados: caracteristicasComValoresPossiveis } = await caracteristicasRepositorio.listarAtributos({
          tipo_do_atributo: "igual.caracteristica",
          id: `em.(${idsDasCaracteristicas.join(",")})`
        })

        const dadosComplementaresDasCaracteristicas = caracteristicasComValoresPossiveis.map(caracteristica => {
          return {
            id: caracteristica.id,
            valor: caracteristica.valor,
            listaDeMultiplaEscolha: caracteristica.listaDeMultiplaEscolha,
            valoresPossiveis: caracteristica.valoresPossiveis,
          }
        })

        const caracteristicasCompletas = caracteristicasComValor.map(({ id, nomeDoAtributo, tipoDoValor, valor }) => {
          const existeCodigoIdentificador = tipoDoValor === "codigo_identificador" && dadosComplementaresDasCaracteristicas.find(dado => dado.id === id)?.valor
          const valorEhData = typeof(valor) === "string" && tipoDoValor === "data"

          const definirValorFinal = () => {
            if (existeCodigoIdentificador) {
              return dadosComplementaresDasCaracteristicas.find(dado => dado.id === id)?.valor.toString()
            }

            if (valorEhData) {
              return adicionarUmDia(new Date(valor))
            }

            return valor
          }

          return {
            id,
            nomeDoAtributo,
            tipoDoValor,
            valor: definirValorFinal() || null,
            deletavel: false,
            valoresPossiveis: dadosComplementaresDasCaracteristicas.find(dado => dado.id === id)?.valoresPossiveis,
            listaDeMultiplaEscolha: dadosComplementaresDasCaracteristicas.find(dado => dado.id === id)?.listaDeMultiplaEscolha,
          }
        })

        return caracteristicasCompletas
      }

      this.estagioDaRequisicao = estados.PEDENTE
      const caracteristicasRepositorio = new AtributosRepositorio()
      const caracteristicasComValor = this.caracteristicas
      const idsDasCaracteristicasDoProfissional = caracteristicasComValor.map(caracteristica => caracteristica.id)
      const existemCaracteristicasAdicionais = idsDasCaracteristicasDoProfissional.length > 0

      try {
        if (existemCaracteristicasAdicionais) {
          this.caracteristicas = await buscarCaracteristicasDoProfissional(idsDasCaracteristicasDoProfissional)
        } else {
          this.caracteristicas = await buscarAtributos()
        }
          this.estagioDaRequisicao = estados.SUCESSO
      } catch (erro) {
        this.estagioDaRequisicao = estados.ERRO
        console.error(erro)
      }
    },
    removerCaracteristica(id: string) {
      this.caracteristicas = this.caracteristicas.filter((car) => car.id !== id)
    },
    resetarCaracteristicas() {
      this.$reset()
    },
  },
})
